// extracted by mini-css-extract-plugin
export default {"heading":"created-quotes_heading__vAswE","container":"created-quotes_container__9EtWg","describe":"created-quotes_describe__zlNJD","actions":"created-quotes_actions__tDGan"};